import {SET_REFRESH_ORDER_DETAIL} from "./RefreshOrderDetailTypes"

export function refreshOrderDetailReducer(state = false, action) {

    if (action.type === SET_REFRESH_ORDER_DETAIL) state = action.data;

    return state;


}
